import editableData from "./siteEditable.json";

export const brand = {
  name: "TheCareerSpace",
  shortName: "TheCareerSpace",
  tagline: "Education",
  summary:
    "TheCareerSpace supports students and families with structured, transparent admission guidance for bachelor's, master's, MBBS pathways, and undergraduate programs abroad.",
  trustLine: "Student-first counselling. Parent-friendly clarity."
};

export const primaryNavigation = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Colleges", to: "/colleges" }
];

export const admissionNavigation = [
  { label: "Bachelor's in India", to: "/bachelors-india" },
  { label: "Master's in India", to: "/masters-india" },
  { label: "MBBS in India", to: "/mbbs-india" },
  { label: "MBBS Abroad", to: "/mbbs-abroad" }
];

export const abroadNavigation = [
  { label: "USA", flag: "🇺🇸", href: "https://nexteraabroad.com/study-in/usa" },
  { label: "UK", flag: "🇬🇧", href: "https://nexteraabroad.com/study-in/uk" },
  { label: "Canada", flag: "🇨🇦", href: "https://nexteraabroad.com/study-in/canada" },
  { label: "Australia", flag: "🇦🇺", href: "https://nexteraabroad.com/study-in/australia" },
  { label: "Dubai", flag: "🇦🇪", href: "https://nexteraabroad.com/study-in/dubai" },
  { label: "Singapore", flag: "🇸🇬", href: "https://nexteraabroad.com/study-in/singapore" },
  { label: "Ireland", flag: "🇮🇪", href: "https://nexteraabroad.com/study-in/ireland" },
  { label: "Germany", flag: "🇩🇪", href: "https://nexteraabroad.com/study-in/germany" },
  { label: "New Zealand", flag: "🇳🇿", href: "https://nexteraabroad.com/study-in/new-zealand" }
];

export const socialLinks = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/careerspaceedu?igsh=MXZ6N2pxbHY0MGppZg==",
    platform: "instagram"
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/the-career-space-education/?viewAsMember=true",
    platform: "linkedin"
  }
];

export const footerNavigation = {
  quickLinks: [
    { label: "Home", to: "/" },
    { label: "About", to: "/about" },
    { label: "Featured Colleges", to: "/colleges" },
    { label: "Contact", to: "/contact" }
  ],
  serviceLinks: [
    {
      label: "Undergraduate Abroad",
      href: "https://nexteraabroad.com/",
      external: true
    },
    ...admissionNavigation
  ],
  policyLinks: [
    { label: "Contact", to: "/contact" }
  ]
};

export const contactInfo = editableData.contactInfo;
